/**
 * Base API Configuration with RTK Query
 */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { RootState } from '../store';

const baseUrl = import.meta.env.VITE_API_URL || 'https://rafal-hcs-backend.sass.cyparta.com/api/v1';
// const baseUrl = 'http://localhost:8000/api/v1';

export const api = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: [
    'User',
    'Users',
    'Service',
    'Services',
    'SubService',
    'SubServices',
    'InternalSubService',
    'Order',
    'Orders',
    'Review',
    'Reviews',
    'Specialist',
    'Specialists',
    'Consultant',
    'Consultants',
    'Payment',
    'Payments',
    'Statistics',
    'Settings',
    'Ad',
    'Ads',
    'Terms',
    'About',
    'Contact',
    'ContactMessages',
    'PermissionCategory',
    'PermissionCategories',
    'Permission',
    'Permissions',
    'Role',
    'Roles',
    'Employee',
    'Employees',
    'OrderResult',
    'PatientMedicalFile',
    'ProviderDocuments',
    'Patient',
    'Patients',
    'MarketplaceCategory',
    'MarketplaceCategories',
    'MarketplaceSubCategory',
    'MarketplaceSubCategories',
    'MarketplaceProduct',
    'MarketplaceProducts',
    'MarketplaceOrder',
    'MarketplaceOrders',
    'MarketplacePayments',
  ],
  endpoints: () => ({}),
});

